const projects = [
    {
        "date": "2024-01-15",
        "title": "STCDataScienceClub.github.io",
        "subtitle": "Club WebSite",
        "description": "Team Organization web site used to hold club projects. The site is built by the club and will at some point have a better description.",
        "imageKey": "githubpages",
        "linkText": "Repo",
        "link": "https://github.com/STCDataScienceClub/STCDataScienceClub.github.io"
    },{
        "date": "2024-02-1",
        "title": "Data Structures and Algorithims",
        "subtitle": "Club WebSite",
        "description": "Content for Data Structures and practice",
        "imageKey": "dsAlgo",
        "linkText": "Repo",
        "link": "https://github.com/STCDataScienceClub/DS_ALGO"
    }

]

export default projects;